import React from "react";
import { Stack, IStackTokens, Text } from "office-ui-fabric-react";
import { ICardTokens, Card } from "@uifabric/react-cards";
import { useHistory } from "react-router-dom";
import { CUSTOMER_CARD_TYPES } from "../common/Constants";
import { GS } from "../../utils/Styles";

export interface CustomerCardProps {
  customerId: any;
}

const CustomerCard: React.FC<CustomerCardProps> = ({ customerId }) => {
  //hooks
  const childrenGap24: IStackTokens = { childrenGap: 24 };
  const cardTokens: ICardTokens = { childrenMargin: 16 };
  const history = useHistory();

  const viewCardContent = (customerId: string, customerCardName: string) => {
    history.push(`/customers/${customerId}/${customerCardName}`);
  };

  return (
    <React.Fragment>
      <Stack tokens={childrenGap24} className="pt-8">
        <Stack.Item>
          <div className="ms-Grid">
            <div className="ms-Grid-row">
              {CUSTOMER_CARD_TYPES.map((item, index) => (
                <div
                  className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl3 ms-xxl2 infrastructure-card-alignment"
                  key={index}
                >
                  <Card
                    className="ms-motion-scaleDownIn card-width infrastructure-card"
                    horizontal
                    styles={{ root: { ...GS.bgWhite } }}
                    tokens={cardTokens}
                  >
                    <Card.Section className="m-0 padding-16" grow={1}>
                      <Stack
                        horizontal
                        horizontalAlign="space-between"
                        className="pointer cardItem"
                        styles={{ root: { width: "100%", height: "130px" } }}
                        onClick={() =>
                          viewCardContent(customerId as string, item.value)
                        }
                      >
                        <Stack.Item>
                          <Text className="infrastructure-card-title">
                            {item.label}
                          </Text>
                        </Stack.Item>
                        <Stack.Item align="end">
                          <img
                            src={item.imageUrl}
                            alt={item.label}
                            style={{ height: item.height, width: item.width }}
                            className="infrastructure-card-image"
                          />
                        </Stack.Item>
                      </Stack>
                    </Card.Section>
                    {/* <div className="card-bg-image">
                      <img src={CradBgImage} alt="card-bg" />
                    </div> */}
                  </Card>
                </div>
              ))}
            </div>
          </div>
        </Stack.Item>
      </Stack>
    </React.Fragment>
  );
};

export default CustomerCard;
